import { VarClassEnum, VHCRecordLogInput } from 'api/generated';
import { useIsInIframe } from 'features/notifications/hooks/use-is-in-Iframe';
import { useCreateRecordMutation } from 'features/vhc/api/create-record.mutation';
import { useCommonUpdateCdkMileageMutation } from 'features/vhc/api/use-common-update-cdk-mileage.mutation';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

type FormState = {
  branchId?: number;
} & VHCRecordLogInput;

export const useVhcCreateForm = () => {
  const isInIframe = useIsInIframe();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    getValues,
    trigger
  } = useForm<FormState>({
    defaultValues: {
      wipNo: '',
      regNo: '',
      carDescription: '',
      varclass: VarClassEnum.NotChosen,
      vin: '',
      customerName: '',
      mileage: undefined,
      soHeaderId: undefined,
      branchId: undefined
    },
    mode: 'onChange'
  });

  const { mutateAsync: handleCreate, isLoading: isCreating } = useCreateRecordMutation();
  const { mutateAsync: handleUpdateCdkMileage, isLoading: isLoadingUpdateCdkMileage } =
    useCommonUpdateCdkMileageMutation();
  const baseUrl = isInIframe ? `/public/vhc` : `/vhc/record`;

  const onSubmit = async (data: FormState) => {
    if (!isValid) return;
    debugger;
    const id = await handleCreate({
      requestBody: data
    });

    const mileage = getValues('mileage');
    const vin = getValues('vin');

    if (!vin || !mileage) {
      navigate(`${baseUrl}/${id}`);
      return;
    }

    try {
      await handleUpdateCdkMileage({
        vin: vin,
        mileage: mileage!
      });
    } finally {
      navigate(`${baseUrl}/${id}`);
    }
  };

  const handleClose = () => {
    navigate(baseUrl);
  };

  return {
    control,
    handleSubmit,
    errors,
    isValid,
    setValue,
    getValues,
    trigger,
    onSubmit,
    handleClose,
    isCreating: isLoadingUpdateCdkMileage || isCreating
  };
};
